"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAttributeFilterConfigurationHandling = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = require("react");
var sdk_model_1 = require("@gooddata/sdk-model");
var model_1 = require("../../../../model");
var safeSerializeObjRef_1 = require("../../../../_staging/metadata/safeSerializeObjRef");
function useAttributeFilterConfigurationHandling(widget, displayFormRef, onAppliedChanged) {
    var _a = tslib_1.__read(react_1.useState("ok"), 2), status = _a[0], setStatus = _a[1];
    var ref = sdk_model_1.widgetRef(widget);
    var ignoreKpiFilter = model_1.useDashboardCommandProcessing({
        commandCreator: model_1.ignoreFilterOnKpiWidget,
        successEvent: "GDC.DASH/EVT.KPI_WIDGET.FILTER_SETTINGS_CHANGED",
        errorEvent: "GDC.DASH/EVT.COMMAND.FAILED",
        onBeforeRun: function () {
            onAppliedChanged(false);
        },
    }).run;
    var unignoreKpiFilter = model_1.useDashboardCommandProcessing({
        commandCreator: model_1.unignoreFilterOnKpiWidget,
        successEvent: "GDC.DASH/EVT.KPI_WIDGET.FILTER_SETTINGS_CHANGED",
        errorEvent: "GDC.DASH/EVT.COMMAND.FAILED",
        onBeforeRun: function () {
            onAppliedChanged(true);
            setStatus("loading");
        },
        onError: function () {
            setStatus("error");
        },
        onSuccess: function () {
            setStatus("ok");
        },
    }).run;
    var ignoreInsightFilter = model_1.useDashboardCommandProcessing({
        commandCreator: model_1.ignoreFilterOnInsightWidget,
        successEvent: "GDC.DASH/EVT.INSIGHT_WIDGET.FILTER_SETTINGS_CHANGED",
        errorEvent: "GDC.DASH/EVT.COMMAND.FAILED",
        onBeforeRun: function () {
            onAppliedChanged(false);
        },
    }).run;
    var unignoreInsightFilter = model_1.useDashboardCommandProcessing({
        commandCreator: model_1.unignoreFilterOnInsightWidget,
        successEvent: "GDC.DASH/EVT.INSIGHT_WIDGET.FILTER_SETTINGS_CHANGED",
        errorEvent: "GDC.DASH/EVT.COMMAND.FAILED",
        onBeforeRun: function () {
            onAppliedChanged(true);
            setStatus("loading");
        },
        onError: function () {
            setStatus("error");
        },
        onSuccess: function () {
            setStatus("ok");
        },
    }).run;
    var handleIgnoreChanged = react_1.useCallback(function (ignored) {
        var ignore = sdk_model_1.isInsightWidget(widget) ? ignoreInsightFilter : ignoreKpiFilter;
        var unignore = sdk_model_1.isInsightWidget(widget) ? unignoreInsightFilter : unignoreKpiFilter;
        if (ignored) {
            unignore(ref, displayFormRef);
        }
        else {
            ignore(ref, displayFormRef);
        }
    }, [
        sdk_model_1.isInsightWidget(widget),
        safeSerializeObjRef_1.safeSerializeObjRef(displayFormRef),
        safeSerializeObjRef_1.safeSerializeObjRef(ref),
        ignoreInsightFilter,
        ignoreKpiFilter,
        unignoreInsightFilter,
        unignoreKpiFilter,
    ]);
    return {
        status: status,
        handleIgnoreChanged: handleIgnoreChanged,
    };
}
exports.useAttributeFilterConfigurationHandling = useAttributeFilterConfigurationHandling;
//# sourceMappingURL=useAttributeFilterConfigurationHandling.js.map